import { useMemo } from 'react'

import { Spinner } from '../../components'
import { useUser } from '../../contexts/user/user-context'
import { ROLES } from '../../lib/constants'
import { Dashboard } from '../dashboard'
import { InvestorDashboard } from '../investor-dashboard'
import { ValidatorDashboard } from '../validator-dashboard'

export function DashboardHub() {
    const { userProfile, loading } = useUser()

    const role = useMemo(() => {
        //@ts-ignore
        const profile = userProfile?.getUserProfile
        const role = profile?.activeRole
        return role ?? 'INDIVIDUAL'
    }, [userProfile])

    if (loading) {
        return (
            <div>
                <Spinner />
            </div>
        )
    }

    if (role === ROLES.INDIVIDUAL || role === ROLES.ADMIN) {
        return <Dashboard />
    }
    if (role === ROLES.LIQUIDITY_PROVIDER) {
        return <InvestorDashboard />
    }

    if (role === ROLES.VALIDATOR) {
        return <ValidatorDashboard />
    }

    return <div>No dashboard found for this role</div>
}
